import { client } from "../../../Infrastructure/agent";

export const WRFMSettingService = {
  loadFlowStations: () => client.get("/setting/loadFlowStations"),
  createFlowstation: (flowstation) =>
    client.post("/setting/CreateFlowstation", { flowstation }),
  loadFields: () => client.get("/setting/loadFields"),
  createField: (field) => client.post("/setting/CreateField", { field }),

  loadWells: () => client.get("/setting/loadWells"),
  createWell: (well) => client.post("/setting/CreateWell", { well }),

  loadLevels: () => client.get("/setting/LoadLevels"),
  createLevel: (level) => client.post("/setting/CreateLevel", { level }),

  loadMonthlyDeckSettings: () =>
    client.get("/setting/LoadMonthlyProductionInputDeckSettings"),

  saveMonthlyDeckSettings: (setting, uploadedBy) =>
    client.post("/setting/SaveMonthlyProductionInputDeckSettings", {
      setting,
      uploadedBy,
    }),

  loadMappings: () => client.get("/setting/LoadFlowstationMapping"),
  createMapping: (mapping) =>
    client.post("/setting/CreateMapping", { mapping }),

  loadOperatingCapacity: () => client.get("/setting/LoadFlowstationCapacity"),
  createCapacity: (capacity) =>
    client.post("/setting/CreateCapacity", { capacity }),
};

